/*
import { ContactService } from '../service/contact';
const cs = new ContactService();
const _init=async()=>{
    console.log(await ob.getContact({user_id:0}));
};
*/

import { API_ROUTE_CONTROLLER,API_VERBS } from "./route";
import { BaseService } from "./base";
import Cookies from 'universal-cookie';
import { API_HOST } from "../config";

const cookies = new Cookies();

export class ProfileSeting extends BaseService {


    getApi = async(url)=>{
        return await this.getResponse(await this.get(url));
    };
    postApi = async(url,_body)=>{
        return await this.getResponse(await this.post(url,_body));
    };
    patchApi = async(url,_body)=>{
        return await this.getResponse(await this.patch(url,_body));
    };

    createHubspot = async (_body, _action, _id, method = "") => {
        let _url = "https://api.hubapi.com/crm/v3/objects/" + _action + "/" + _id;
        let _method = 'PATCH';
        if (method != "") _method = method;
      
        if (_action == "associations") {
          _method = 'PUT';
          _url = "https://api.hubapi.com/crm-associations/v1/" + _action + "/" + _id;
        } else if (_action == "companies") {
          //_method = 'DELETE';
          _url = "https://api.hubapi.com/crm/v3/objects/companies/" + _id;
        }else if (_action == "contacts") {
          _url = "https://api.hubapi.com/crm/v3/objects/contacts/" + _id;
        } else {
          if (_action == "delete") {
            //_method = 'DELETE';
            _url = "https://api.hubapi.com/contacts/v1/contact/vid/" + _id;
          } else {
      
          }
        }
      
        try {
          const requestOptionsNew = {
            method: "POST",
            header: {
              "accept": "application/json",
              "content-type": "application/json"
            },
            body: JSON.stringify({
              method: _method,
              url: _url,
              properties: {
                properties: _body
              }
            })
            //
          }
          const url = API_ROUTE_CONTROLLER.hubspot_api
          const response = await fetch(
            url, requestOptionsNew
          )
      
          const jsonResp = await response.json();
          if (jsonResp != null) {
            return jsonResp;
          } else {
            return null;
          }
        } catch {
          return null;
        }
      };

      getWorkingHours = async (company_id,huntgroup_id) => {
        const url = API_ROUTE_CONTROLLER.Urmyaccounthuntgroupgetcustomhour;
        const body = {
          "Company_id": company_id,
          "hunt_groupid": huntgroup_id
        };
        return await this.getResponse(await this.post(url,body));
      };

      getHuntgroupDetails_new = async (company_id,huntgroup_id) => {
        const url = API_ROUTE_CONTROLLER.Urmyacccountgethuntgroupdtl;
        const body = {
          "company_id": company_id,
          "groupid": huntgroup_id,
        };
        return await this.getResponse(await this.post(url,body));
      };

      getMusicType = async () => {
        const url = API_ROUTE_CONTROLLER.Urmyaccwebivrgetmusictype;
        return await this.getResponse(await this.get(url));
      };
    

}
